const initialState = {
  items: [],
  count: 0,
  item: null,
  isLoading: false
};

export function plfReducer(state = initialState, action) {
  const { data, plf: item, type, error } = action;
  switch (type) {
    case 'PLF_ERROR':
      return Object.assign({}, state, {
        isLoading: false,
        error
      });
    case 'PLF_GET':
    case 'PLF_CREATE':
    case 'PLF_UPDATE':
      return Object.assign({}, state, {
        item: null,
        isLoading: true
      });
    case 'PLF_CREATE_OK':
    case 'PLF_UPDATE_OK':
    case 'PLF_GET_OK':
      return Object.assign({}, state, {
        item,
        isLoading: false
      });
    case 'PLF_GET':
      return Object.assign({}, state, {
        items: [],
        count: 0,
        isLoading: true
      });
    case 'PLFS_OK':
      return Object.assign({}, state, {
        items: data.items,
        count: data.count,
        isLoading: false
      });

    default:
      return state;
  }
}
